import { render, staticRenderFns } from "./UpdateRecord.vue?vue&type=template&id=ac83493c"
import script from "./UpdateRecord.vue?vue&type=script&lang=js"
export * from "./UpdateRecord.vue?vue&type=script&lang=js"
import style0 from "./UpdateRecord.vue?vue&type=style&index=0&id=ac83493c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports